import { useQueryClient } from '@tanstack/react-query';
import { useCancelOrder, useDeleteOrderById } from '@/hooksApi/useOrder';
import { OrderStatusTab } from '@/types';

const useHandleCancelOrder = (uid: string | number, activeTab: OrderStatusTab, statusSlug?: string) => {
  const queryClient = useQueryClient();
  const { mutateAsync: CancelOrder, isLoading: CancelOrderLoading } = useCancelOrder();
  const { mutateAsync: DeleteOrder, isLoading: DeleteOrderLoading } = useDeleteOrderById();

  const handleCancelOrder = async () => {
    // Only "new" orders should be deleted; scheduled/collecting/collected must be cancelled
    const shouldDelete = statusSlug === 'new' || (activeTab === OrderStatusTab.READY_TO_SHIP && !statusSlug);

    if (shouldDelete) {
      await DeleteOrder(String(uid), {
        onSuccess() {
          queryClient.invalidateQueries(['order-count']);
          queryClient.invalidateQueries();
        },
      });
    } else {
      await CancelOrder(String(uid), {
        onSuccess() {
          queryClient.invalidateQueries(['order-count']);
          queryClient.invalidateQueries();
        },
      });
    }
  };

  return { handleCancelOrder, isLoading: CancelOrderLoading || DeleteOrderLoading };
};
export default useHandleCancelOrder;
